export default __webpack_public_path__ + "5073eda570c8d80a79453505491fa709.png";